<template>
  <div>
    <img :src="require(`@/assets/img/flags/${code}.svg`)"
         :height="height">
    <span>{{text}}</span>
  </div>
</template>

<script>
export default {
  name: 'Flag',
  props: {
    code: {
      require: true,
      type: String,
    },
    text: {
      type: String,
      default: '',
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>

<style lang="scss" scoped>
  div {
    display: table;
    margin: 0 4px -2px;
    span {
      font-weight: 700;
      padding-left: 10px;
      display: table-cell;
      vertical-align: middle;
    }
  }
</style>
